import { useEffect, useState } from 'react';
import { Card, Space, Switch, Typography, message } from 'antd';
import { BellOutlined } from '@ant-design/icons';
import { getSpaceTelegramNotify, setSpaceTelegramNotify } from './api';

const { Paragraph } = Typography;

/**
 * Личные уведомления в Telegram для всего пространства: упоминание в
 * комментарии и назначение в поле приходят человеку в переписку с ботом.
 * Включает админ пространства; каждый участник может выключить их у себя
 * в профиле.
 */
export function TelegramSpaceNotifyCard({
  spaceId,
  isAdmin,
}: {
  spaceId: string;
  isAdmin: boolean;
}): JSX.Element {
  const [enabled, setEnabled] = useState<boolean | null>(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    getSpaceTelegramNotify(spaceId)
      .then((s) => setEnabled(s.enabled))
      .catch(() => setEnabled(false));
  }, [spaceId]);

  const handleChange = async (next: boolean) => {
    setSaving(true);
    try {
      const saved = await setSpaceTelegramNotify(spaceId, next);
      setEnabled(saved.enabled);
      void message.success(next ? 'Уведомления в Telegram включены' : 'Уведомления в Telegram выключены');
    } catch (err) {
      void message.error(err instanceof Error ? err.message : 'Не удалось сохранить');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Card
      size="small"
      style={{ marginBottom: 16 }}
      data-testid="telegram-space-notify"
      title={
        <Space>
          <BellOutlined />
          Личные уведомления
        </Space>
      }
      extra={
        <Switch
          checked={enabled ?? false}
          loading={enabled === null || saving}
          disabled={!isAdmin}
          onChange={handleChange}
          checkedChildren="вкл"
          unCheckedChildren="выкл"
          data-testid="telegram-space-notify-switch"
        />
      }
    >
      <Paragraph type="secondary" style={{ marginBottom: 0 }}>
        Бот пишет человеку в личную переписку, когда его упомянули в комментарии или указали в поле
        записи (исполнитель, ответственный и т. п.). Приходит тем, кто связал аккаунт Telegram с Lens.
        Каждый может выключить уведомления у себя в профиле — совсем или только для этого пространства.
      </Paragraph>
    </Card>
  );
}
